// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SupportLinks {\n  border-top: 1px solid #ddddde;\n  margin: 0 -24px;\n  padding: 8px 24px 4px;\n}\n.SupportLinks__contact-link,\n.SupportLinks__issues-link {\n  height: 32px;\n  text-decoration: none;\n  display: inline-flex;\n}\n.SupportLinks__contact-link {\n  margin-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
